import { ShowCargaEdicionExcelModalForm } from "./ShowCargaEdicionExcelModalForm"


const ShowCargaEdicionExcelModalFormWrapper = () => {
    return (<ShowCargaEdicionExcelModalForm />)
}

export {ShowCargaEdicionExcelModalFormWrapper}